import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import CrowdStrikeSpotlightConfigListing from './CrowdStrikeSpotlightConfigListing'
import CrowdStrikeSpotlightCredentialsForm from './CrowdStrikeSpotlightCredentialsForm'

export default function CrowdStrikeSpotlightPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={CrowdStrikeSpotlightCredentialsForm}
            PullConfigListingView={CrowdStrikeSpotlightConfigListing}
        />
    )
}